<div class="verify-otp-comp-container">
  
  <div class="verify-otp-form">
    <div class="header">
      <button
        pButton
        (click)="backButton()"
        class="back-button"
        severity="secondary"
        icon="ph ph-caret-left"
        aria-label="Back"></button>
      <dk-progress-bar [progressValues]="progressValues"></dk-progress-bar>
      <span class="title-text">{{ 'doktar_app.auth.enter_code_title' | translate }}</span>
      <span class="subtitle-text">
        @if (isEmailChannel) {
          {{ 'doktar_app.auth.enter_code_email_description' | translate: { arg1: verifyOtpInfo } }}
        } @else {
          {{ 'doktar_app.auth.enter_code_phone_description' | translate: { arg1: verifyOtpInfo } }}
        }
      </span>
    </div>

    <p-inputotp
      dkOtpPaste
      [(ngModel)]="otpValue"
      [maxlength]="6"
      [length]="6"
      [integerOnly]="true"
      [autofocus]="true"
      class="custom-otp-input"
      [ngClass]="{ 'error-border': !otpValidationStatus }"
      (onBlur)="otpValidationStatus = true">
    </p-inputotp>

    @if (!otpValidationStatus) {
      <div class="error-container">
        <span class="error-text">
          {{ backendErrorMessage | translate }}
        </span>
      </div>
    }

    <div class="verify-otp-buttons">
      <p-button
        [text]="true"
        [link]="true"
        [label]="
          resendCodeCounter === 0
            ? ('doktar_app.auth.enter_code_resend_button' | translate)
            : ('doktar_app.auth.enter_code_resend_button_w_time' | translate: { arg1: formattedResendCodeCounter })
        " 
        [style]="{ 'padding': '0px' }"
        (click)="resendCodeTrigger()"
        [disabled]="resendCodeCounter !== 0"></p-button>
      @if (showResendHelpText) {
        <div class="resend-help-container">
          <span class="resend-help-text">
            {{ 'doktar_app.auth.enter_code_contact_us' | translate: { arg1: 'doktar_app.common.support_email_address' | translate } }}
          </span>
        </div>
      }
      <dk-button
        class="continue-button"
        [size]="'xlarge'"
        [label]="'doktar_app.common.confirm_button' | translate"
        [disabled]="!otpValue || otpValue.toString().length !== 6"
        [loading]="confirming"
        (onClick)="confirmVerifyOtp()"></dk-button>
    </div>
  </div>
</div>
